import CONSTANTS from "../constant/general";

export const getKeyByValue = (object: Record<string, string>, value: string) => {
  return Object.keys(object).find(key =>
    object[key] === value);
}

export const getBuildSearchParams = (location: any) => {
  const [ _, queryString = '' ] = location.hash?.split('?') || [];
  const params = new URLSearchParams(queryString);
  const obj = Object.fromEntries([ ...params ])
  if (obj && Object.keys(obj).length > 0) {
    return {
      ...(obj[CONSTANTS.COMMAND] && { [CONSTANTS.COMMAND]: obj[CONSTANTS.COMMAND] }),
      ...(obj[CONSTANTS.DEFAULT_RPID] && { [CONSTANTS.RPID]: obj[CONSTANTS.DEFAULT_RPID] }),
      ...(obj[CONSTANTS.DESIGN_UUID] && { [CONSTANTS.DESIGN_UUID]: obj[CONSTANTS.DESIGN_UUID] }),
    }
  }
  return {}
}

export const getDiamondId = (currentUrl: string) => {
  const match = currentUrl.match(/diamondId=([^&]*)/);
  return match?.[1]?.split("?").find(item => item) || '';
}

export const getStyleId = (currentUrl: string) => {
  const match_styleId = currentUrl.match(/styleId=([^&]*)/);
  return match_styleId?.[1] || '';
}

export const getThreeDFileName = (type: "head" | "shank"| "bands", category?: "stud-earrings") => {
  switch (type) {
    case "head":
      return  category === "stud-earrings" ? "earring" : "head";
    case "shank":
      return  category === "stud-earrings" ? "earring" : "shank";
    case "bands":
      return  category === "stud-earrings" ? "earring" : "bands";
  }
}

export const getLocalStorageData = (key: string) => {
  const item = localStorage.getItem(key);
  if (!item) return null;
  try {
    return JSON.parse(item);
  } catch (error) {
    console.error(`Error parsing localStorage item "${key}":`, error);
    return null;
  }
};